import {
  blocksOptionsConfig,
  newCollectionTemplate,
} from "@components/cmsBlocks/configs";
export const collectionType = blocksOptionsConfig.collectionTypes.popular.value;

export const config = newCollectionTemplate({
  typeFields: {
    title: "text",
    slug: "text",
    setId: null,
    setType: "",
    setTitle: "",
    isShow: "boolean",
  },
  itemTemplate: {
    title: "",
    slug: "",
    setId: null,
    setType: "",
    setTitle: "",
    isShow: true,
  },
  type: collectionType,
  showAsTitle: "title", // only texts fields
  allowUseSets: true,
});

// export const config1 = {
//   typeFields: {
//     title: "text",
//     slug: 'text',
//     setId: null,
//     setType: "",
//     setTitle: "",
//   },
//   itemTemplate: {
//     title: "",
//     slug: '',
//     setId: null,
//     setType: "",
//     setTitle: "",
//   },
//   type: collectionType,
//   showAsTitle: "title", // only texts fields
//   allowUseSets: true,
// };

export const initBlockData = {
  title: "Popular links",
  collections: {
    [collectionType]: {
      ...config,
      items: [],
    },
  },
};
export const initEmptyBlockData = {
  title: "",
  collections: {
    [collectionType]: {
      ...config,
      items: [],
    },
  },
};
